import React from "react";
import { Lock } from "lucide-react";

/**
 * The quantity lock on a stocked invoice's line grid (D44 #20, #50-#53).
 *
 * `StockedQuantityLockNote` says it once above the grid and offers the way
 * forward, so nobody has to meet a refusal first. `LockedCellValue` is what a
 * locked cell shows in place of the click-to-edit cell.
 */
export function StockedQuantityLockNote({ onRaiseReturn }: { onRaiseReturn?: () => void }) {
  return (
    <div
      role="note"
      aria-label="Quantities are locked"
      className="px-3 py-1.5 border-b border-slate-200 bg-slate-50 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-600"
    >
      <span className="inline-flex items-center gap-1.5">
        <Lock className="h-3 w-3 text-slate-400" aria-hidden="true" />
        In stock: quantities can&apos;t be changed and lines can&apos;t be added or removed. Goods short,
        damaged or wrong go back on a vendor return.
      </span>
      {onRaiseReturn ? (
        <button
          type="button"
          onClick={onRaiseReturn}
          className="rounded border border-purple-200 bg-purple-50 px-2 py-0.5 text-xs font-semibold text-purple-700 hover:bg-purple-100"
        >
          Raise a vendor return
        </button>
      ) : null}
    </div>
  );
}

export function LockedCellValue({ value, title }: { value: unknown; title: string }) {
  const shown = value === undefined || value === null || value === "" ? null : String(value);
  return (
    <div className="w-full px-2 py-1 min-w-0 whitespace-pre-wrap break-words cursor-not-allowed" title={title}>
      {shown !== null ? (
        <span className="text-slate-900">{shown}</span>
      ) : (
        <span className="text-slate-400 italic">empty</span>
      )}
      <Lock className="ml-1 inline h-3 w-3 align-[-1px] text-slate-400" aria-hidden="true" />
      <span className="sr-only"> (locked: {title})</span>
    </div>
  );
}
